// extracted by mini-css-extract-plugin
module.exports = {"title":"SaleListHeader_title__d1t_U","btnMore":"SaleListHeader_btnMore__PRuoL","btnAll":"SaleListHeader_btnAll__Wh5P0","moreOptions":"SaleListHeader_moreOptions__xCOua"};